var _templateObject;
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { getFont } from '@finect/tabular-utils/getFont';
import styled, { css } from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { animationPop } from '../utils/animations';
var HORIZONTAL_PADDING = 12;
var headingStyles = function headingStyles(index) {
  return css(["display:inline-block;", ";font-weight:700;"], getFont(index, 'compact'));
};
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1jat1tl-0"
})(["padding-bottom:12px;border-radius:", ";box-shadow:", " 0 0 0 2px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiM;
});
export var FeaturedFieldBlock = styled.div.withConfig({
  displayName: "partials__FeaturedFieldBlock",
  componentId: "sc-1jat1tl-1"
})(["margin-bottom:18px;", ";", ";"], headingStyles(2), minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), headingStyles(3)));
export var MetadataBlock = styled.div.withConfig({
  displayName: "partials__MetadataBlock",
  componentId: "sc-1jat1tl-2"
})(["display:", ";padding:6px ", "px;", " ", " &:after{display:block;content:'';}"], function (_ref3) {
  var _ref3$fullWidth = _ref3.fullWidth,
    fullWidth = _ref3$fullWidth === void 0 ? false : _ref3$fullWidth;
  return fullWidth ? 'block' : 'flex';
}, HORIZONTAL_PADDING, function (_ref4) {
  var _ref4$topMargin = _ref4.topMargin,
    topMargin = _ref4$topMargin === void 0 ? false : _ref4$topMargin;
  return topMargin ? 'margin-top: 16px;' : '';
}, getFont(-1));
export var Definition = styled.div.withConfig({
  displayName: "partials__Definition",
  componentId: "sc-1jat1tl-3"
})(["display:", ";align-items:center;"], function (_ref5) {
  var _ref5$display = _ref5.display,
    display = _ref5$display === void 0 ? 'flex' : _ref5$display;
  return display;
});
export var Additional = styled.div.withConfig({
  displayName: "partials__Additional",
  componentId: "sc-1jat1tl-4"
})(["flex-shrink:0;padding-left:6px;margin-left:auto;"]);
export var Title = styled.div.withConfig({
  displayName: "partials__Title",
  componentId: "sc-1jat1tl-5"
})(["display:inline;"]);
export var Value = styled.div.withConfig({
  displayName: "partials__Value",
  componentId: "sc-1jat1tl-6"
})(["display:", ";font-weight:500;word-break:break-word;", ""], function (_ref6) {
  var _ref6$display = _ref6.display,
    display = _ref6$display === void 0 ? 'inline' : _ref6$display;
  return display;
}, function (_ref7) {
  var _ref7$display = _ref7.display,
    display = _ref7$display === void 0 ? 'inline' : _ref7$display;
  return ['block'].includes(display) ? 'height: 30px;' : '';
});
export var MainBlock = styled.div.withConfig({
  displayName: "partials__MainBlock",
  componentId: "sc-1jat1tl-7"
})(["&:before{display:block;height:1px;margin:9px ", "px;content:'';background-color:", ";}"], HORIZONTAL_PADDING, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.ui;
});
export var HeaderBlockTop = styled.div.withConfig({
  displayName: "partials__HeaderBlockTop",
  componentId: "sc-1jat1tl-8"
})(["padding:18px ", "px 0;"], HORIZONTAL_PADDING);
export var HeaderActions = styled.div.withConfig({
  displayName: "partials__HeaderActions",
  componentId: "sc-1jat1tl-9"
})(["display:inline;float:right;margin-left:16px;&:after{display:block;}"]);
export var HeartAction = styled.div.withConfig({
  displayName: "partials__HeartAction",
  componentId: "sc-1jat1tl-10"
})(["display:inline;margin-left:9px;cursor:pointer;svg{fill:", ";stroke:", ";", "}"], function (_ref9) {
  var theme = _ref9.theme,
    active = _ref9.active;
  return active ? theme.colors.secondaryD : '#fff';
}, function (_ref10) {
  var theme = _ref10.theme,
    active = _ref10.active;
  return active ? theme.colors.secondaryD : theme.colors.font;
}, function (_ref11) {
  var active = _ref11.active;
  return active && animationPop;
});
export var FactsBlockInner = styled.div.withConfig({
  displayName: "partials__FactsBlockInner",
  componentId: "sc-1jat1tl-11"
})(["color:", ";li{display:inline-flex;}li:not(:last-child){margin-bottom:8px;}svg{flex-shrink:0;margin-right:6px;vertical-align:middle;color:", ";}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.font;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.positive;
});